// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"02da7803","917":"e2854707"}[chunkId] + ".chunk.css";
};